import axios from 'axios'

export default class loginApi {
  static memberGet() {
    return axios.get('/high/member/get')
  }

  static memberGetInfoLogList(data) {
    return axios.get('/high/member/getInfoLogList', { params: data })
  }

  static memberGetTestLogList(data) {
    return axios.get('/high/member/getTestLogList', { params: data })
  }

  static memberCreatePay(data) {
    return axios.post('/high/order/createPay', data)
  }

  static memberOrderState(data) {
    return axios.get('/high/order/getOrderState', { params: data })
  }

  static memberTestLogList(data) {
    return axios.get('/high/member/getTestLogList', { params: data })
  }

  static memberInfoLogList(data) {
    return axios.get('/high/member/getInfoLogList', { params: data })
  }

  static updateChannelType({ channelType }) {
    return axios.post('/high/user/updateChannel', { channelType })
  }

  static getConfig(name) {
    return axios.get('/high/config/get/' + name)
  }
}




// WEBPACK FOOTER //
// ./src/api/vipApi.js